import { DatePipe } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, } from '@angular/common/http';
import { NgModule, Type } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AUTH_TOKEN_INTERCEPTOR_FILTER } from '@core/configs';
import { CompleteRequestsInterceptor, filterInterceptorRequest, JWTInterceptor } from '@core/interceptors';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms';
import { CorpPrefixGuard } from '@core/guard/corp-prefix.guard';
import { LoadingComponent } from '@core/components/loading/loading.component';
import { ProcessLoadingService, ProcessLoadingStackService } from '../app/core/services/common'
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { providePrimeNG } from 'primeng/config';
import Aura from '@primeng/themes/aura';
//FireBase
import { environment } from '@environments/environment';
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';
import { FirebaseAuthInterceptor } from '@core/interceptors/firebase-auth.interceptor';
import { CoreModule } from '@modules/core/core.module';
import { COMMON_TEXT } from '@core/constants';
import { SaucerLogService } from '@core/services/saucer-logs/saucer-log.service';

@NgModule({
  declarations: [
    AppComponent,
    LoadingComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    // HttpClientModule,
    AppRoutingModule,
    FormsModule,
    CoreModule
  ],
  providers: [
    provideHttpClient(withInterceptorsFromDi()), // Thay thế HttpClientModule
    // { provide: APP_BASE_HREF, useValue: '/' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CompleteRequestsInterceptor,
      multi: true,
    },
    {
      provide: AUTH_TOKEN_INTERCEPTOR_FILTER,
      useValue: filterInterceptorRequest,
    },
    // { provide: HTTP_INTERCEPTORS, useClass: FirebaseAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: JWTInterceptor, multi: true },
    SaucerLogService,
    DatePipe,
    CorpPrefixGuard,
    ProcessLoadingService,
    ProcessLoadingStackService,
    provideAnimationsAsync(),
    providePrimeNG({ 
        theme: {
          preset: Aura
        },
        translation: {
          selectionMessage: COMMON_TEXT.ITEM_SELECTED,
          emptyMessage: COMMON_TEXT.NO_DATA,
          // Japanese labels for the datepicker (caremoni-custom-calendar): "9月" months and 日〜土 weekdays.
          firstDayOfWeek: 0,
          monthNames: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          monthNamesShort: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
          dayNames: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
          dayNamesShort: ['日', '月', '火', '水', '木', '金', '土'],
          dayNamesMin: ['日', '月', '火', '水', '木', '金', '土']
        }
    }),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideDatabase(() => getDatabase()),
    provideAuth(() => getAuth()), 
    {provide: FIREBASE_OPTIONS, useValue: environment.firebaseConfig },

  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
